import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments';
import {PrismHeaders} from '../enums';
import {map} from 'rxjs/operators';
import {Response} from '../models';

@Injectable({
    providedIn: 'root'
})
export class ShareAlbumService {

    constructor(private http: HttpClient) {
    }

    shareJobAsAgency({shareLink, notificationEmails, comments, address}) {
        return this.http.post(`${environment.apiBaseUrl}/member-share-album-as-agency`, {shareLink, notificationEmails, comments, address});
    }

    shareAlbum(notificationData, {street}, {jobId, agencyId, agentId, mainMemberUid}) {
        return this.http.post(`${environment.apiBaseUrl}/member-share-album`, {notificationData, street, jobId, agencyId, agentId, mainMemberUid});
    }

    async getNotificationEmails({agency: agencyId, agent: agentId}) {
        if (!!agentId) {
            const headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify({agentId}));
            return this.http.get(`${environment.apiBaseUrl}/member-get-agent`, {headers})
                .pipe(
                    map((res: Response) => res.data.notificationEmails)
                ).toPromise();
        } else if (!!agencyId) {
            const headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify({agencyId}));
            return this.http.get(`${environment.apiBaseUrl}/member-get-agency`, {headers})
                .pipe(
                    map((res: Response) => res.data.notificationEmails)
                ).toPromise();
        } else {
            return Promise.resolve([]);
        }
    }
}
